import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { User } from '@rocksoft/security-sdk';

export function selectUserIdfromUser(user: User) {
  return user.id;
}

export const adapter: EntityAdapter<User> = createEntityAdapter<User>({
  selectId: selectUserIdfromUser,
});

export type SuggestedUserState = EntityState<User>;

export const initialState: SuggestedUserState = adapter.getInitialState();
